import { render, staticRenderFns } from "./FullPageBackground.vue?vue&type=template&id=32cbc266&scoped=true&"
import script from "./FullPageBackground.vue?vue&type=script&lang=js&"
export * from "./FullPageBackground.vue?vue&type=script&lang=js&"
import style0 from "./FullPageBackground.vue?vue&type=style&index=0&id=32cbc266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cbc266",
  null
  
)

export default component.exports